import React from 'react'
import Navigation from "../Components/Navigation";


export default function Contributing() {
    return (
        <>
        <Navigation />
            
        </>
    )
}
